<button class="button-undecorated scroll-to-top" (click)="scrollToTop()" *transloco="let t">
    <cwo-icon [name]="iconNameType.arrowUp" class="icon" />
    <span class="text">{{t('modals.special_item_editor.buttons.scroll_to_top')}}</span>
</button>